import {useState} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import { useSelector } from 'react-redux'
import TVuelos from '../../ProveedoresVuelos/TVuelos'
import RowCircuito from './RowCircuito'

const columns = [
  { id: "1", minWidth: 70, align: "center", label: 'Clave' },
  { id: "2", minWidth: 100, align: "center", label: 'Fecha inicio' },
  { id: "3", minWidth: 100, align: "center", label: 'Fecha fin' },
  { id: "4", minWidth: 100, align: "center", label: 'Disponibilidad' },
  // { id: "5", minWidth: 50, align: "center", label: 'Dias' },
  // { id: "6", minWidth: 50, align: "center", label: 'Noches' },
  // { id: "7", minWidth: 50, align: "center", label: 'Suplemento' },
  { id: "5", minWidth: 50, align: "center", label: 'Vuelos Asignados' },
  { id: "6", minWidth: 50, align: "center", label: 'Vuelos' },
  { id: "7", minWidth: 50, align: "center", label: 'Detalle' }
]

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: "auto",
  },
  container: {
    maxHeight: 310,
  },
})

export default function TCircuitosProveedor() {
  const classes = useStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const {arrayCircuitos} = useSelector(store => store.proveedorTerrestre)
  const rows = arrayCircuitos ?? []

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              return (
                <RowCircuito key={row.IdPaqueteCircuito} circuito={row} />
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <TVuelos />
    </Paper>
  )
}